import React from 'react';
import { useIntl } from 'react-intl';

const StepWizard = ({ step, stepForm, showIcon = true }) => {
  const translate = useIntl();

  return (
    <div className="wizard__steps-container">
      <div className="wizard__steps">
        {stepForm.map((item, index) => {
          const customClass = `wizard__step ${step === index ? 'active' : ''}`;
          const completeClass = `icon-check-circle ${step > index ? 'active' : ''}`;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div className={customClass} key={item + index}>
              {showIcon && <i className={completeClass} />}
              {index + 1}
              .
              {' '}
              {translate.formatMessage(item)}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StepWizard;
